import { Settinglable } from '../models/setting'
import { Tenant, TenantCategory, toJson } from '../models/tenant'
import { TenentSettinglable } from '../models/tenantSetting'
import { ADMIN_API_PREFIX, API_PREFIX } from './constant'
import { ContentType, MultiPartFormData, Request } from './request'

export interface TenantQueryParams {
  current?: number
  endTimeHead?: string
  endTimeTail?: string
  name?: string
  tenantCategory?: TenantCategory
  size?: number
  area?: string
  provinceCode?: string
  cityCode?: string
  countyCode?: string
  openType?: number
  _dateRange?: any
  sort?: number
  status?: number
}

export function getTenantList(params: TenantQueryParams): Request {
  return {
    url: `${ADMIN_API_PREFIX}/tenant/list`,
    method: 'GET',
    params,
  }
}

export function getTenantDetail(tenantId: string): Request {
  return {
    url: `${ADMIN_API_PREFIX}/tenant/detail`,
    method: 'GET',
    params: {
      tenantId,
    },
  }
}

export function createOrUpdateTenant(tenant: Tenant): Request {
  return {
    url: `${ADMIN_API_PREFIX}/tenant/save`,
    method: 'POST',
    body: toJson(tenant),
  }
}

// 批量重置接口
export interface VolumeGrantMenusParams {
  tenantIds: string[]
  menuIds: string[]
}

export function volumeGrantMenus(body: VolumeGrantMenusParams): Request {
  return {
    url: `${ADMIN_API_PREFIX}/tenantmenu/addBatch`,
    method: 'POST',
    body,
  }
}

// 批量增值服务接口
export interface ResetSettingParams {
  tenantIds: any[]
  functionList: Settinglable[]
}
export function resectSettingLabel(body: ResetSettingParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/tenant/function/saveBatchFunction`,
    method: 'POST',
    body,
  }
}

// 批量机构模板详情
export interface TemplateDetailParams {
  tenantId: any
}
export function templateDetail(params: TemplateDetailParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatmenttemplate/templateDetail`,
    method: 'GET',
    params,
  }
}

// 批量机构模板详情
export function templateDetailSecond(params: TemplateDetailParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatmenttemplate/templateDetailSecond`,
    method: 'GET',
    params,
  }
}

// 批量模板复制保存接口
export interface CopyBatchParams {
  tenantIds: any[]
  tenantId: any
  templateIds: any[]
}
export function copyBatchSubmit(body: CopyBatchParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatmenttemplateitem/copyBatch`,
    method: 'POST',
    body,
  }
}

export function copyBatchSubmitSecond(
  body: CopyBatchParams
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatmenttemplateitem/copyBatchSecond`,
    method: 'POST',
    body,
  }
}

// 批量机构目录详情
export interface DirectoryReplicationDetailParams {
  tenantId: any
}
export function directoryReplicationDetail(
  params: DirectoryReplicationDetailParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/materialscatalog/tenantInfo`,
    method: 'GET',
    params,
  }
}
export function directoryReplicationDetailSecond(
  params: DirectoryReplicationDetailParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/materialscatalog/tenantInfoSecond`,
    method: 'GET',
    params,
  }
}

// 批量目录复制保存接口
export interface CopyDirectoryReplicationParams {
  tenantIds: any[]
  tenantId: any
  // flag: any
  templateIds: any[]
  materialsList: any[]
  treatmentList: any[]
}
export function copyDirectoryReplicationSubmit(
  body: CopyDirectoryReplicationParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/materialscatalog/copyBatch`,
    method: 'POST',
    body,
  }
}

export function copyDirectoryReplicationSubmitSecond(
  body: CopyDirectoryReplicationParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/materialscatalog/copyBatchSecond`,
    method: 'POST',
    body,
  }
}

export function toggleTenantState(tenantId: string): Request {
  return {
    url: `${ADMIN_API_PREFIX}/tenant/logoutOrEnable`,
    method: 'POST',
    params: {
      tenantId,
    },
  }
}

export interface AllParams {
  regionLevel?: number
  parentRegionCode?: string
  current?: number
  size?: number
}
// 省市区
export function getProvince(params: AllParams): Request {
  return {
    url: `${ADMIN_API_PREFIX}/api/city/list`,
    method: 'GET',
    params,
  }
}

// 所有省市区
export function getAll(): Request {
  return {
    url: `${ADMIN_API_PREFIX}/api/city/alldata`,
    method: 'GET',
  }
}
export interface ExportExcelParams {
  current?: number
  endTimeHead?: string
  endTimeTail?: string
  name?: string
  tenantCategory?: TenantCategory
  size?: number
  area?: string
  provinceCode: any
  cityCode: any
  countyCode: any
}
// 导出
export function getExportExcel(body: ExportExcelParams): Request {
  return {
    url: `${ADMIN_API_PREFIX}/tenant/log/exportexcel`,
    method: 'POST',
    responseType: 'blob',
    body,
  }
}

export interface tenantDataInitParams {
  tenantId: number;
  materialsCatalog?: boolean; //药品目录
  treatmentCatalog?: boolean; //诊疗目录
  inventoryReceipts?: boolean; //库存单据
  inventoryLedger?: boolean; //库存台账
  payment?: boolean; //结算记录
  treatment?: boolean ; //病历信息
  patient?: boolean; //患者信息
  code?:string;//验证码
}
export interface ImportExcelParams {
  file?: any
}
// 导入
export function getImportExcel(params: ImportExcelParams): Request {
  return {
    url: `${ADMIN_API_PREFIX}/tenant/openaccount`,
    headers: {
      [ContentType]: MultiPartFormData,
    },
    method: 'POST',
    params,
  }
}
// 订单导入
export function orderImportExcel(params: ImportExcelParams): Request {
  return {
    url: `${ADMIN_API_PREFIX}/m/order/importbatchNew`,
    headers: {
      [ContentType]: MultiPartFormData,
    },
    method: 'POST',
    params,
  }
}
export interface BatchOpenReplaceMakeParams {
  openGranuleType: number
  openHerbType: number
  openPriceRatio?: number
  printBarCode?: number
  openType: number
  recipeType: number
  tenantIds: any[]
}
// 开通代煎设置
export function batchOpenReplaceMake(
  body: BatchOpenReplaceMakeParams
): Request {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/potionBinding/openPotionBindingSaveBatch`,
    method: 'POST',
    body,
  }
}

export interface OpenReplaceMakeParams {
  openGranuleType: number
  openHerbType: number
  openType: number
  printBarCode?: number
  recipeType: number
  tenantId: number
}
// 开通代煎设置
export function openReplaceMake(body: OpenReplaceMakeParams): Request {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/potionBinding/openPotionBindingSave`,
    method: 'POST',
    body,
  }
}

// 代煎设置回显
export function settingReplaceMake(id: number): Request {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/potionBinding/getPotionBinding`,
    method: 'GET',
    params: {
      tenantId: id,
    },
  }
}

// 订单管理列表
export interface getOrderListFnParams {
  cityCode?: number
  countyCode?: number
  createEndTime?: string
  createStartTime?: string
  current?: number
  duration?: number
  productId?: number
  provinceCode?: number
  size?: number
  tenantId?: number
  tenantName?: number
}

export interface getServerListFnParams {
  provinceCode?: number
  cityCode?: number
  countyCode?: number
  
  productId?: number
  tenantId?: number
  tenantName?: number
  deadLineStart?: Date
  deadLineEnd?: Date
  status?: number

  current?: number
  size?: number
}


export function getOrderListFn(body: getOrderListFnParams): Request {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/order/getPage`,
    method: 'POST',
    body,
  }
}

export function getServerListFn(body: getServerListFnParams): Request {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/order/getTenantServer`,
    method: 'POST',
    body,
  }
}

// 订单管理-产品价格列表

export function getOrderPriceListFn(): Request {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/order/selectProductList`,
    method: 'POST',
  }
}
// 订单管理-新增订单
export interface getAddOrderFnParams {
  amount?: number
  discountNum?: number
  durationNum?: string
  price?: number
  productId?: number
  remark?: number
  tenantId?: number
  totalAmount?: number
  endTime?: string
}
export function getAddOrderFn(body: getAddOrderFnParams): Request {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/order/saveOrder`,
    method: 'POST',
    body,
  }
}

// 订单管理-修改订单
export interface updateOrderFnParams {
  id?: string
  amount?: number
  remark?: string
  serveEndTime?: string
}
export function updateOrderFn(body: updateOrderFnParams): Request {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/order/updateOrder`,
    method: 'POST',
    body,
  }
}
// 续订价格列表
export function getPriceListFn(params: getOrderListFnParams): Request {
  return {
    // url: `${ADMIN_API_PREFIX}/blade-administer/m/order/getProductPricePage`,
    url: `${ADMIN_API_PREFIX}/blade-administer/tenantRenewalPriceItem/page`,
    method: 'GET',
    params,
  }
}

// 续订价格详情
export function priceDetail(tenantId: any): Request {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/tenantRenewalPriceItem/detail`,
    method: 'GET',
    params: {
      tenantId,
    },
  }
}

export interface priceDetailSubmitParams {
  tenantId?: number
  tenantIdList?:[]
  tenantRenewalPriceItemList?: []
  allProductIds?: number[]
}
// 续订价格保存
export function priceDetailSubmit(body: priceDetailSubmitParams): Request {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/tenantRenewalPriceItem/submit`,
    method: 'POST',
    body,
  }
}


// 获取行政编码
export function getInsuranceCode(insuranceCode: string): Request {
  return {
    url: `${API_PREFIX}/blade-insurance/insuranceMapping/getInsuranceCode`,
    method: 'POST',
    body: {
      insuranceCode,
    },
  }
}
// 机构管理-标签
export interface getTenantLabelListFnParams {
  tenantId?: string
}
export function getTenantLabelListFn(
  params: getTenantLabelListFnParams
): Request {
  return {
    url: `${API_PREFIX}/blade-administer/tenant/getTenantDetailsTag`,
    method: 'POST',
    params,
  }
}
// 获取标签管理-列表
export interface getLabelListFnParams {
  current?: number
  name?: number
  size?: number
}
export function getLabelListFn(params: getLabelListFnParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/label/list`,
    method: 'GET',
    params,
  }
}
// 获取标签管理-新增or 编辑
export interface getLabelAddFnParams {
  name?: string
  id?: number
  headName?: string
  fontColor?: string
  backgroundColor?: string
}
export function getLabelAddFn(body: getLabelAddFnParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/label/save`,
    method: 'POST',
    body,
  }
}

export const getExportFn = (body: getOrderListFnParams): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/order/getPageExportExcel`,
    method: 'POST',
    responseType: 'blob',
    body,
  }
}

export const getLiveTenantsExportFn = (): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/board/exportSimpleTenantToExcel`,
    method: 'GET',
    responseType: 'blob',
  }
}
